import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// RasPm Dashboard components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// NewMilestone page components
import FormField from "components/Form/FormField";
import { RequestService } from "services/RequestService";
import Autocomplete from "@mui/material/Autocomplete";
import { useEffect, useState, useRef } from "react";

function EditForm({ formData }) {
  const { formField, values, errors, touched, setFieldValue } = formData;
  const {
    description,
    ResponsibilityText: responsibilityText,
    SolutionDescription: solutionDescription,
    startDate,
    endDate,
    priority,
    Status,
    projectId,
  } = formField;
  const {
    description: descriptionV,
    startDate: startDateV,
    endDate: endDateV,
    priority: priorityV,
    Status: StatusV,
    projectId: projectIdV,
    responsibilityText: responsibilityTextV,
    solutionDescription: solutionDescriptionV,
  } = values;
  const [riskStatus, setriskStatus] = useState([]);
  const [priorityStatus, setPriorityStatus] = useState([]);

  const isOptionEqualToValue = (option, value) => option.id === value.id;
  // read project id from url
  const urlParams = new URLSearchParams(window.location.search);
  const projectIdParam = urlParams.get("projectId");
  useEffect(() => {
    setFieldValue("projectId", projectIdParam);
    let options = [];
    let options2 = [];
    RequestService.get("Risk/riskStatusList").then((res) => {
      if (res && res.data && res.status === 200 && res.data.data != null) {
        let js = res.data.data;
        Object.keys(js).forEach((key) => {
          options.push({ label: key, value: js[key] });
        });
      }
    });
    RequestService.get("Risk/priorityList").then((res) => {
      if (res && res.data && res.status === 200 && res.data.data != null) {
        let js = res.data.data;
        Object.keys(js).forEach((key) => {
          options2.push({ label: key, value: js[key] });
        });
      }
    });
    setPriorityStatus(options2);
    setriskStatus(options);
  }, []);
  return (
    <MDBox>
      <MDBox lineHeight={0}>
        <MDTypography variant="h5">معلومات المخاطر</MDTypography>
      </MDBox>
      <MDBox mt={1.625}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormField
              type={description.type}
              label={description.label}
              name={description.name}
              value={descriptionV}
              placeholder={description.placeholder}
              error={errors.description && touched.description}
              success={!errors.description}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={responsibilityText.type}
              label={responsibilityText.label}
              name={responsibilityText.name}
              value={responsibilityTextV}
              placeholder={responsibilityText.placeholder}
              error={errors.responsibilityText && touched.responsibilityText}
              success={!errors.responsibilityText}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={solutionDescription.type}
              label={solutionDescription.label}
              name={solutionDescription.name}
              value={solutionDescriptionV}
              placeholder={solutionDescription.placeholder}
              error={errors.solutionDescription && touched.solutionDescription}
              success={!errors.solutionDescription}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={startDate.type}
              label={startDate.label}
              name={startDate.name}
              value={startDateV}
              placeholder={startDate.placeholder}
              error={errors.startDate && touched.startDate}
              success={startDateV.length > 0 && !errors.startDate}
              // style={{ backgroundColor: "yellow" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormField
              type={endDate.type}
              label={endDate.label}
              name={endDate.name}
              value={endDateV}
              placeholder={endDate.placeholder}
              error={errors.endDate && touched.endDate}
              success={endDateV.length > 0 && !errors.endDate}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
          <FormField
            type={priority.type}
            label={priority.label}
            name={priority.name}
            value={priorityV}
            placeholder={priority.placeholder}
            error={errors.priority && touched.priority}
            success={priorityV >= 0 && !errors.priority}
          />
        </Grid> */}
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={priorityStatus}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={priority.label}
                  value={priority}
                  name={priority.name}
                  placeholder={priority.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("priorityId", v.value);
                setFieldValue("priority", v.value);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={riskStatus}
              isOptionEqualToValue={isOptionEqualToValue}
              renderInput={(params) => (
                <FormField
                  {...params}
                  variant="standard"
                  label={Status.label}
                  value={Status}
                  name={Status.name}
                  placeholder={Status.placeholder}
                />
              )}
              onChange={(e, v) => {
                setFieldValue("statusId", v.value);
                setFieldValue("status", v.value);
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    </MDBox>
  );
}

EditForm.propTypes = {
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default EditForm;
